import React, { useState, useCallback } from 'react';
import { Form, Button, Space } from 'antd';
import { useQuery } from '@tanstack/react-query';
// import { useAtomValue } from 'jotai';
// import { isMobileAtom } from '@/jotai/atoms/userAtom';
// import SearchForm from './components/SearchForm';
import BenefitTable from './components/BenefitTable';
import BenefitDrawer from './components/BenefitDrawer';
import { getBenefitList } from './api';
import { BenefitSearchParams, BenefitRecord } from './types';
import { QUERY_KEYS } from './constants';

const DEFAULT_PAGE_SIZE = 10;

const MemberBenefitPage: React.FC = () => {
  // const isMobile = useAtomValue(isMobileAtom);
  const [form] = Form.useForm<BenefitSearchParams>();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [editingBenefit, setEditingBenefit] = useState<BenefitRecord | null>(null);

  const { data, isLoading, refetch } = useQuery({
    queryKey: [QUERY_KEYS.BENEFIT_LIST, currentPage, form.getFieldsValue()],
    queryFn: async () => {
      const values = form.getFieldsValue();
      return getBenefitList({
        ...values,
        currentPage,
        pageSize,
      });
    },
  });

  // const resetPageAndRefetch = useCallback(() => {
  //   setCurrentPage(1);
  //   refetch();
  // }, [refetch]);

  // const handleSearch = useCallback(() => {
  //   resetPageAndRefetch();
  // }, [resetPageAndRefetch]);

  // const handleReset = useCallback(() => {
  //   form.resetFields();
  //   resetPageAndRefetch();
  // }, [form, resetPageAndRefetch]);

  const handleTableChange = useCallback((page: number, size?: number) => {
    setCurrentPage(page);
    if (size && size !== pageSize) {
      setPageSize(size);
      setCurrentPage(1); // 切换每页条数时重置到第一页
    }
  }, [pageSize]);

  const openDrawer = useCallback((benefit: BenefitRecord | null = null) => {
    setEditingBenefit(benefit);
    setDrawerOpen(true);
  }, []);

  const closeDrawer = useCallback(() => {
    setDrawerOpen(false);
    setEditingBenefit(null);
  }, []);

  const handleDrawerSuccess = useCallback(() => {
    refetch();
  }, [refetch]);

  return (
    <div>
      <Space style={{ marginBottom: 16, width: '100%', justifyContent: 'space-between' }}>
        {/* <SearchForm
          form={form}
          onSearch={handleSearch}
          onReset={handleReset}
        /> */}
        <Button type="primary" onClick={() => openDrawer(null)}>
          新增
        </Button>
      </Space>

      <BenefitTable
        data={data?.records || []}
        loading={isLoading}
        pagination={{
          current: currentPage,
          pageSize,
          total: data?.total || 0,
          onChange: handleTableChange,
        }}
        onEdit={openDrawer}
      />

      <BenefitDrawer
        open={drawerOpen}
        editingBenefit={editingBenefit}
        onClose={closeDrawer}
        onSuccess={handleDrawerSuccess}
      />
    </div>
  );
};

export default MemberBenefitPage;
